import { Pipe, PipeTransform } from '@angular/core';

import {
  SENTIMENT_COLOR_3_SCALE,
  SENTIMENT_COLOR_5_SCALE,
  SENTIMENT_ICON_3_SCALE,
  SENTIMENT_ICON_5_SCALE,
  SentimentColor,
} from 'app/modules/collection/components/sentiment-display/sentiment-display.component';
import { Document } from 'app/providers/storage-api/document.service';
import { SentimentPolarityRange } from 'app/providers/storage-api/project.service';
import { SentimentUtils } from 'app/utils/sentiment.utils';

@Pipe({
  name: 'experienceCardSentiment',
  standalone: false,
})
export class ExperienceCardSentimentPipe implements PipeTransform {
  transform(
    item: Document,
    displayedColumns: string[],
    sentimentScale: number,
    sentimentRanges: SentimentPolarityRange[],
    isIcon?: boolean
  ): string | boolean {
    const includeSentiment = displayedColumns?.includes('sentiment');
    const sentimentPolarity = SentimentUtils.getSentimentValueFromRange(
      item.analyses[0].sentimentScore,
      sentimentRanges,
      sentimentScale
    );

    if (isIcon) {
      return includeSentiment
        ? this.getSentimentIcon(sentimentPolarity, sentimentScale)
        : undefined;
    }

    return includeSentiment
      ? this.getSentimentColor(sentimentPolarity, sentimentScale)
      : SentimentColor.DEFAULT;
  }

  private getSentimentIcon(polarityVal: string, sentimentScale: number): string {
    if (sentimentScale === 5) {
      return SENTIMENT_ICON_5_SCALE[polarityVal];
    }

    return SENTIMENT_ICON_3_SCALE[polarityVal];
  }

  private getSentimentColor(polarityVal: string, sentimentScale: number): string {
    if (sentimentScale === 5) {
      return SENTIMENT_COLOR_5_SCALE[polarityVal];
    }

    return SENTIMENT_COLOR_3_SCALE[polarityVal] ?? SentimentColor.DEFAULT;
  }
}
